<template>
  <div class="drawer" v-if="!!documents.length">

    <!-- Header 1 -->
    <div class="drawer-header">
      <!-- Title -->
      <div class="title">
        {{ $t('mp_list.documents') }}
      </div>
    </div>

    <!-- Header 2 -->
    <div class="drawer-header-2">
      <!-- Tab -->
      <div class="tab">
        <template>
          <v-btn depressed small
            v-if="doc_mode==0" color="primary">
            {{ $t('mp_list.in_masterpiece') }}
          </v-btn>
          <v-btn text small @click="doc_mode=0"
            v-else>{{ $t('mp_list.in_masterpiece') }}</v-btn>
        </template>
        <template>
          <span class="vertical-line"/>
          <v-btn depressed small 
            v-if="doc_mode==1" color="primary">
            {{ $t('mp_list.in_tree') }}
          </v-btn>
          <v-btn text small @click="doc_mode=1"
            v-else>{{ $t('mp_list.in_tree') }}</v-btn>
        </template>
      </div>

      <div class="list-header">
        <div class="header-align">
          <template v-if="doc_mode==0">
            <div>{{ $t('mp_list.in_masterpiece') }}</div>
          </template>
          <template v-if="doc_mode==1">
            <div>{{ $t('mp_list.in_tree') }}</div>
          </template>
          <div class="primary--text">{{ mode_documents.length }}</div>
        </div>

        <div class="header-align">
          
          <!-- <template>
            <div>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn x-small icon v-on="on">
                    <v-icon small>mdi-sort-descending</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="sort_by=0">
                    {{ $t('sorting.title_a') }}
                    <v-icon v-if="sort_by==0" color="green" small>mdi-check</v-icon>
                  </v-list-item>
                  <v-list-item @click="sort_by=1">
                    {{ $t('sorting.title_d') }}
                    <v-icon v-if="sort_by==1" color="green" small>mdi-check</v-icon>
                  </v-list-item>
                  <v-list-item @click="sort_by=2">
                    {{ $t('sorting.date_a') }}
                    <v-icon v-if="sort_by==2" color="green" small>mdi-check</v-icon>
                  </v-list-item>
                  <v-list-item @click="sort_by=3">
                    {{ $t('sorting.date_d') }}
                    <v-icon v-if="sort_by==3" color="green" small>mdi-check</v-icon>
                  </v-list-item>
                  <v-list-item @click="sort_by=4">
                    {{ $t('sorting.author_a') }}
                    <v-icon v-if="sort_by==4" color="green" small>mdi-check</v-icon>
                  </v-list-item>
                  <v-list-item @click="sort_by=5">
                    {{ $t('sorting.author_d') }}
                    <v-icon v-if="sort_by==5" color="green" small>mdi-check</v-icon>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template> -->
        </div>
      </div>

      <!-- Search -->
      <div class="search">
        <v-text-field
          v-model="search_keyword"
          hide-details
          solo flat
          background-color="grey lighten-5"
          clearable
          single-line
          append-icon="mdi-magnify"
          placeholder="Search..."
        ></v-text-field>
      </div>
    </div>

    <!-- List -->
    <section :key="list_key">
      <div class="list-wrapper scrollbox">
        <div class="scrollbox-content">
          <div class="doc-card"
            @mouseenter="setHoveredKey(doc, true)"
            @mouseleave="hovered_key=null"
            v-for="(doc, index) in index_documents" :key="index">

            <div class="doc-row">

              <div class="row-contents">
                <div class="contents-title">
                  <span :style="setColor(doc.doc_type)">{{ index + 1 }}</span>
                  <span class="list-title-content">{{ doc.title }}</span>
                </div>
                <div class="contents-mid">
                  <span v-if="doc.authors_iso690!='N.R., null'">
                    {{ doc.authors_iso690 }}
                  </span>
                  <span v-if="!!doc.date">
                    ({{ doc.date }})
                  </span>
                </div>
                <div class="contents-details">
                  <span v-if="!!doc.publication">
                    {{ doc.publication }}
                  </span>
                  <span v-if="!!doc.number">
                    <span>{{ doc.number }}</span>
                  </span>
                  <span v-if="!!doc.publisher">
                    <span v-if="!!doc.publication||!!doc.number"> - </span>
                    <span>{{ doc.publisher }}</span>
                  </span>
                </div>
                <div>
                </div>
              </div>

              <div class="row-footer">
                <div v-if="!!hovered_key && (hovered_key==doc.key||hovered_key==doc.doc_key)">
                  
                  <!-- Like -->
                  <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon x-small v-on="on"
                        @click="likeDocument(doc.key, doc.my_like)">
                        <v-icon small v-if="!doc.my_like">
                          mdi-heart-outline
                        </v-icon>
                        <v-icon small v-else color="secondary">mdi-cards-heart</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('mp_list.like_document') }}</span>
                  </v-tooltip> -->

                  <!-- Fork -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon x-small v-on="on"
                        @click.stop="openForkDoc(doc.key)">
                        <v-icon small>mdi-source-fork</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('mp_list.fork_document') }}</span>
                  </v-tooltip>

                  <!-- URL: Google scholar -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon x-small v-on="on"
                        @click="gaClick('piece_btn_google')"
                        :href="getURL(doc.title)" target="_blank">
                        <v-icon small>mdi-google</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('mp_list.google_scholar') }}</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
            
          </div>
        </div>

      </div>
    </section>

    <section class="pagination" v-if="num_pages>1">
      <v-pagination
        v-model="page_index"
        :length="num_pages"
        :total-visible="6"
      ></v-pagination>
    </section>

    <!-- Modals -->
    <modal-fork-document
      :dialog.sync="dialog_doc_fork"
      :dockey.sync="fork_doc_key">
    </modal-fork-document>

  </div>
</template>

<script>
import { sort_opts, doc_types } from '../../../custom/model'
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    sortby: {
      type: Number,
      required: true,
    },

    documents: {
      type: Array,
      required: true,
    },

    legend: {
      type: Array,
      required: true,
    },

    index: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      busy: false,
      list_key: 0,

      sort_opts: sort_opts,
      doc_types: doc_types,
      sort_by: this.sortby,

      view_mode: 'list',

      doc_mode: 0,
      pre_mode_doc_keys: [],

      filtered_documents: [],
      index_documents: [],
      num_pages: 0,
      num_docs: 20,
      page_index: 1,

      search_keyword: null,

      dialog_doc_fork: false,
      fork_doc_key: "",

      hovered_key: null,
    }
  },

  computed: {
    ...mapGetters({
      mp_info: 'gallery/masterpiece',
      node_documents: 'tree/node_documents',
      expired: 'auth/is_expired',
    }),

    mode_documents() {
      if (this.doc_mode==0) { return JSON.parse(JSON.stringify(this.documents))}
      else if (this.doc_mode==1) { return JSON.parse(JSON.stringify(this.node_documents))}
    },

    doc_keys() {
      return this.documents.map(v => v.key)
    },

    mode_doc_keys() {
      return this.mode_documents.map(v => v.key)
    },

    is_filtered() {
      return this.mode_documents.length != 
        this.filtered_documents.length
    },

    mp_id() {
      return parseInt(this.$route.params.id)
    },
  },

  watch: {
    mp_id: {
      async handler(val) {
        await this.$store.dispatch('project/getProjects')
      },
      immediate: true,
    },

    sort_by(val) {
      this.$emit('update:sortby', val)
    },

    mode_doc_keys: {
      handler(val) {
        let confirm = true
        if (val.length == this.pre_mode_doc_keys.length) {
          for (let i=0; i<val.length; i++) {
            confirm = val[i] == this.pre_mode_doc_keys[i] && confirm
          }
        } else { confirm = false }
        if (!confirm) {
          this.pre_mode_doc_keys = JSON.parse(JSON.stringify(val))
          this.filtered_documents = JSON.parse(JSON.stringify(this.mode_documents))
          this.list_key += 1
        }
      },
      deep: true,
      immediate: true
    },

    filtered_documents: {
      handler(val) {
        this.num_pages = Math.ceil(val.length / this.num_docs)
        this.page_index = 1
        this.index_documents = 
          val.slice((this.page_index-1)*this.num_docs, 
            this.page_index*this.num_docs)
        if(this.is_filtered) {
          this.$emit('update:legend', this.filtered_documents)
        } else {
          this.$emit('update:legend', this.node_documents)
        }
      },
      immediate: true,
      deep: true,
    },

    node_documents: {
      handler(val) {
        if (!this.is_filtered) {
          this.$emit('update:legend', val)
        }
      },
      deep: true,
    },

    page_index: {
      handler(val) {
        this.index_documents = 
          this.filtered_documents.slice((this.page_index-1)*this.num_docs, 
            this.page_index*this.num_docs)
      },
    },

    index_documents: {
      handler(val) {
        this.$emit('update:index', val)
      },
      immediate: true,
      deep: true,
    },

    search_keyword: {
      handler(val) {
        if (!val || !val.length) {
          this.filtered_documents = JSON.parse(JSON.stringify(this.mode_documents))
        } else {
          this.searchList(val)
        }
      },
    },

    doc_mode: {
      handler(val) {
        this.search_keyword = ''
      },
    },
  },

  methods: {
    ...mapMutations({
      showExpiredModal: 'modal/showExpired',
    }),

    setColor(doc_type) {
      let color = this.doc_types[doc_type].color
      return 'color:'+ color
    },

    searchList(keyword) {
      keyword = keyword.toLowerCase()
      this.filtered_documents = this.mode_documents.filter(v => {
        return v.authors_iso690.toLowerCase().includes(keyword) ||
          (!!v.date && v.date.toLowerCase().includes(keyword)) ||
          v.title.toLowerCase().includes(keyword)
      })
    },

    setHoveredKey(doc, mode) {
      let key = !!doc.doc_key ? doc.doc_key : doc.key
      this.hovered_key = key
      if (mode) { this.$store.commit('project/setHoveredKey', key) }
      else { this.$store.commit('project/setHoveredKey', null) }
    },

    // async likeDocument(key, like) {
    //   this.busy = true
    //   let new_like = like == 0 ? 1 : 0
    //   let action = like == 0 ? 'vote' : 'cancel'
    //   let index = this.documents.findIndex(v => v.key == key)
    //   this.$set(this.documents[index], 'my_like', new_like)
    //   let fo_index = this.filtered_documents.findIndex(v => v.key == key)
    //   this.$set(this.filtered_documents[fo_index], 'my_like', new_like)
    //   try {
    //     await this.$store.dispatch('gallery/voteDocument', {
    //       mp_id: this.mp_id,
    //       doc_key: key,
    //       action,
    //     })
    //   } finally {
    //     this.busy = false
    //   }
    // },

    openForkDoc(key) {
      if (this.expired) {
        this.showExpiredModal()
      } else {
        this.fork_doc_key = key
        this.dialog_doc_fork = true
      }
    },

    getURL(title) {
      return 'https://scholar.google.com/scholar?q=' + title.split(" ").join("+")
    },

    gaClick(param) {
      this.$analytics.logEvent('click', { name: param })
    }
  },
}
</script>

<style scoped>

  /* Drawer */

  .drawer {
    height: 100vh;
    border-left: 1px solid #EDEDED;
    background-color: rgba(255, 255, 255, 0.8);
  }

  /* Header */

  .drawer-header {
    background-color: rgba(237, 237, 237, 0.4);
    height: 60px;
    padding: 0px 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .drawer-header-2 {
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .drawer-header-2 .tab {
    padding: 0 24px;
    height: 60px;
    display: flex;
    align-items: center;
  }

  .list-header {
    height: 46px;
    padding: 0 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .drawer-header .header-align {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .drawer-header-2 .header-align {
    font-size: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .header-align > div {
    margin: 0 4px;
    display: flex;
    align-items: center;
  }

  .drawer-header-2 .tab-title {
    margin-right: 16px;
    color: #75787B;
  }

  .drawer-header-2 .search {
    height: 44px;
    padding: 0 24px;
    display: flex;
    align-items: flex-end;
  }

  .icon-number, .header-title {
    font-family: 'Montserrat', sans-serif;
  }

  /* List */

  .list-wrapper {
    padding-top: 12px;
    padding-bottom: 36px;
    height: calc(100vh - 210px);
  }

  /* List - contents */

  .doc-card:hover {
    background-color: rgba(237, 237, 237, 0.4);
  }

  .doc-row {
    display: grid;
    grid-template-columns: auto 18px;
    padding: 12px 24px;
  }

  .doc-row .contents-title {
    font-weight: 600;
    font-size: 15px;
    letter-spacing: -.4px;
  }

  .contents-mid, .contents-details {
    margin-top: 4px;
  }

  .contents-details {
    color:#5F5B4C;
  }

  .row-footer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 3px;
  }

  .row-footer button {
    margin-bottom: 5px;
  }

  .pagination {
    position: absolute;
    width: 450px;
    height: 40px;
    bottom: 0;
    right: 0;
    border-top: 1px solid rgba(237, 237, 237);
    border-left: 1px solid rgba(237, 237, 237);
    background-color: white;
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/spa/gallery/Drawer.vue